import React from 'react';
import {Chip} from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import PropTypes from 'prop-types';
import clsx from 'clsx';
const MultiValue = (props) => {
   return (
      <Chip
         tabIndex={-1}
         label={props.children}
         className={clsx(props.selectProps.classes.chip, {
            [props.selectProps.classes.chipFocused]: props.isFocused
         })}
         onDelete={props.removeProps.onClick}
         deleteIcon={<CancelIcon {...props.removeProps} />}
      />
   );
};

MultiValue.propTypes = {
   children: PropTypes.node,
   isFocused: PropTypes.bool.isRequired,
   removeProps: PropTypes.shape({
      onClick: PropTypes.func.isRequired,
      onMouseDown: PropTypes.func.isRequired,
      onTouchEnd: PropTypes.func.isRequired
   }).isRequired,
   selectProps: PropTypes.object.isRequired
};

export default MultiValue;
